import JSONPointerError from "./JSONPointerError.mjs";
class JSONPointerCompileError extends JSONPointerError {}
export default JSONPointerCompileError;